import React from 'react';
import { Cpu, Code, ArrowLeftRight, Table2, ShieldAlert, Layers } from 'lucide-react';
import { features } from '../mock';

const iconMap = {
  0: Cpu,
  1: Code,
  2: ArrowLeftRight,
  3: Table2,
  4: ShieldAlert,
  5: Layers
};

const Features = () => {
  return (
    <section className="py-24 bg-slate-950 relative overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            ¿Por qué <span className="bg-gradient-to-r from-cyan-400 to-teal-400 text-transparent bg-clip-text">BLOX Core</span>?
          </h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto">
            Un runtime pequeño, controlable y fácil de alojar dentro de software existente. El host decide cuándo cargar, cuándo llamar y cómo aplicar los resultados.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = iconMap[index];
            return (
              <div
                key={feature.id}
                className="group relative bg-slate-900/50 backdrop-blur-sm border border-slate-800 rounded-2xl p-8 hover:border-cyan-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-cyan-500/10 hover:-translate-y-1"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/5 to-teal-500/5 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                <div className="relative">
                  <div className="w-14 h-14 bg-gradient-to-br from-cyan-500/20 to-teal-500/20 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-7 h-7 text-cyan-400" />
                  </div>
                  
                  <h3 className="text-xl font-semibold text-white mb-3 group-hover:text-cyan-400 transition-colors">
                    {feature.title}
                  </h3>
                  
                  <p className="text-slate-400 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;